import { useEffect, useRef, useState } from "react";

export function useCountdown(seconds, active, onExpire, ctl) {
  const [left, setLeft] = useState(seconds);
  const cb = useRef(onExpire);
  const leftRef = useRef(seconds);
  cb.current = onExpire;

  useEffect(() => {
    if (!active) return undefined;
    const end = Date.now() + leftRef.current * 1000;
    const id = setInterval(() => {
      const l = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      leftRef.current = l;
      setLeft(l);
      if (l <= 0) { clearInterval(id); cb.current(); }
    }, 200);
    if (ctl) ctl.current = () => clearInterval(id);
    return () => clearInterval(id);
  }, [active]); // eslint-disable-line react-hooks/exhaustive-deps

  return left;
}

// Same countdown plus freeze(): clears the interval synchronously so the shown value never changes again
export function useFreezableCountdown(seconds, active, onExpire) {
  const [frozen, setFrozen] = useState(false);
  const frozenRef = useRef(false);
  const ctl = useRef(null);
  const left = useCountdown(seconds, active && !frozen, () => { if (!frozenRef.current) onExpire(); }, ctl);
  const shown = useRef(left);
  if (!frozenRef.current) shown.current = left;
  const freeze = () => { if (frozenRef.current) return; frozenRef.current = true; ctl.current?.(); setFrozen(true); };
  return [shown.current, freeze];
}
